import { Link } from "react-router-dom";
import Footer from "../Footer";
import Header from "../Header";

const Iotsolutions = () => {
    return (
        <div className="digital_Marketing_page_wepper">
            <Header />
            <section>
                <div className="fw-main-row middle-content" style={{ backgroundColor: 'f1f1f1' }}>
                    <div className="fw-row">
                        <div className="fw-col-xs-12 ">

                            <div className="fw-divider-space" style={{ marginTop: '120px' }}></div>
                        </div>
                    </div>

                    <div className="fw-container">
                        <div className="fw-row">
                            <div className="fw-col-xs-12 ">

                                <p className="home-services-link"><b><Link to="/home">Home</Link></b> {'>'} <b><Link
                                    to="/services">Services</Link> </b> {'>'} Iot Solutions
                                </p>
                            </div>
                        </div>
                        <div className="fw-row">
                            <div className="fw-col-xs-12 ">

                                <div className="fw-divider-space" style={{ marginTop: '20px' }}></div>
                            </div>
                        </div>
                        <div className="fw-row">
                        </div>
                        <div className="fw-row">
                            <div className="fw-col-xs-12 fw-col-sm-6 fw-col-md-6  ">
                                <h1 className="heading-services-subpage">IoT Solutions and Automation Services</h1>
                                <p className="portfolio-our-agency">We offer top-natch solutions in internet of
                                    things (iot), ar, ibeacon, wearables, gaming & beyond</p>
                                <div className="frame-66-Y1q frame-submit-requir-button">
                                    <div className="frame-66-Y1q-text">Submit Your Requirement</div>
                                    <div className="frame-66-Y1q-arrow"></div>
                                </div>
                            </div>
                            <div className="fw-col-xs-12 fw-col-sm-6 fw-col-md-6  ">
                                <div className="">
                                    <img src="./images/mobile-services-main.webp" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="fw-row">
                            <div className="fw-col-xs-12 ">

                                <div className="fw-divider-space" style={{ marginTop: '60px' }}></div>
                            </div>
                        </div>
                        <div className="fw-main-row middle-content">
                            <div className="fw-container">
                                <div className="fw-row">
                                    <div className="fw-col-xs-12 ">

                                        <div className="fw-divider-space" style={{ marginTop: '60px' }}></div>
                                    </div>
                                </div>
                                <div className="fw-row">
                                    <div className="fw-col-xs-12 ">
                                        <div className="fw-heading fw-heading-h2">
                                            <h2 className='fw-special-title'>ABOUT MOBILE APP DEVELOPMENT</h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="fw-row">
                                    <div className="fw-col-xs-12 fw-col-sm-4 fw-col-md-4  ">
                                        <p className="portflio-deep-dive">Building Compelling Mobile Apps for
                                            iPhone and Android</p>
                                    </div>
                                    <div className="fw-col-xs-12 fw-col-sm-8 fw-col-md-8  ">
                                        <p className="portfolio-our-agency">Key strategies include designing an
                                            intuitive interface, leveraging platform-specific features,
                                            optimizing performance, providing personalization options,
                                            ensuring seamless integration, releasing regular updates, and
                                            incorporating user feedback for continuous improvement. These
                                            strategies help in engaging users and making your app stand out.
                                        </p>
                                    </div>
                                </div>
                                <div className="fw-row">
                                    <div className="fw-col-xs-12 ">

                                        <div className="fw-divider-space" style={{ marginTop: '20px' }}></div>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div className="fw-row">
                            <div className="fw-col-xs-12 fw-col-sm-6 fw-col-md-3 hover_inAll">

                                <div className="frame-1-RTY ">
                                    <img className="window-image"
                                        src="./images/Frame 1000003976appproto.svg" alt="" />
                                    <p className="frame-services-content-1">App Prototyping & Strategy</p>


                                </div>
                            </div>
                            <div className="fw-col-xs-12 fw-col-sm-6 fw-col-md-3 hover_inAll">

                                <div className="frame-1-RTY">
                                    <img className="window-image"
                                        src="./images/Frame 1000003977cloud.svg" alt="" />
                                    <p className="frame-services-content-1">Cloud Mobility Solutions</p>


                                </div>
                            </div>
                            <div className="fw-col-xs-12 fw-col-sm-6 fw-col-md-3 hover_inAll">

                                <div className="frame-1-RTY">
                                    <img className="window-image"
                                        src="./images/Frame 1000003978cross-plat.svg" alt="" />
                                    <p className="frame-services-content-1">Cross-platform App Development</p>


                                </div>
                            </div>
                            <div className="fw-col-xs-12 fw-col-sm-6 fw-col-md-3 hover_inAll">

                                <div className="frame-1-RTY">
                                    <img className="window-image"
                                        src="./images/Frame 1000003979m-commerce.svg" alt="" />
                                    <p className="frame-services-content-1">m-Commerce, B2B & B2C</p>


                                </div>
                            </div>
                        </div>

                        <div className="fw-row">
                            <div className="fw-col-xs-12 fw-col-sm-6 fw-col-md-3 hover_inAll">

                                <div className="frame-1-RTY">
                                    <img className="window-image"
                                        src="./images/Frame 1000003983enterprise.svg" alt="" />
                                    <p className="frame-services-content-1">Enterprise App Development</p>


                                </div>
                            </div>
                            <div className="fw-col-xs-12 fw-col-sm-6 fw-col-md-3 hover_inAll">

                                <div className="frame-1-RTY">
                                    <img className="window-image"
                                        src="./images/Frame 1000003982appmain.svg" alt="" />
                                    <p className="frame-services-content-1">App Maintenance Services</p>


                                </div>
                            </div>
                            <div className="fw-col-xs-12 fw-col-sm-6 fw-col-md-3 hover_inAll">

                                <div className="frame-1-RTY">
                                    <img className="window-image"
                                        src="./images/Frame 1000003981integration.svg" alt="" />
                                    <p className="frame-services-content-1">Integration with existing enterprise
                                        services & data</p>


                                </div>
                            </div>
                            <div className="fw-col-xs-12 fw-col-sm-6 fw-col-md-3 hover_inAll">

                                <div className="frame-1-RTY">
                                    <img className="window-image"
                                        src="./images/Frame 1000003980custommobile.svg" alt="" />
                                    <p className="frame-services-content-1">Custom Mobile App Development</p>


                                </div>
                            </div>
                        </div>


                        <div className="fw-row">
                            <div className="fw-col-xs-12 fw-col-sm-4 fw-col-md-4 ">


                            </div>
                            <div className="fw-col-xs-12 fw-col-sm-4 fw-col-md-4 ">

                                <div className="frame-66-Y1q frame-submit-requir-button">
                                    <div className="frame-66-Y1q-text">
                                        <Link to="/contact-us">
                                            Let's Discuss Your Project
                                        </Link>


                                    </div>
                                    <div className="frame-66-Y1q-arrow"></div>
                                </div>
                            </div>
                            <div className="fw-col-xs-12 fw-col-sm-4 fw-col-md-4 ">


                            </div>

                        </div>




                        <div className="fw-row">
                            <div className="fw-col-xs-12 ">

                                <div className="fw-divider-space" style={{ marginTop: '40px' }}></div>
                            </div>
                        </div>



                        <div className="fw-row">
                            <div className="fw-col-xs-12 ">
                                <div className="fw-heading fw-heading-h2">
                                    <h2 className='fw-special-title' style={{ textAlign: 'center' }}>INDUSTRIES</h2>
                                </div>
                            </div>
                        </div>


                        <div className="fw-row">
                            <div className="fw-col-xs-12  ">
                                <p className="portflio-deep-dive" style={{ textAlign: 'center' }}>Mobile apps
                                    spanning a range of industries</p>
                            </div>
                            <div className="fw-col-xs-12 ">
                                <p className="portfolio-our-agency" style={{ textAlign: 'center' }}>Key strategies
                                    include designing an intuitive interface</p>
                            </div>
                        </div>
                        <div className="fw-row">
                            <div className="fw-col-xs-12 ">

                                <div className="fw-divider-space" style={{ marginTop: '60px' }}></div>
                            </div>
                        </div>
                        <div className="fw-row" style={{ display: 'flex' }}>
                            <div className="fw-col-indus hover_inAll">
                                <div className="frame-2-IJU" style={{ backgroundColor: 'black' }}>
                                    <img className="hc-image" src="./images/industries-healthcare.svg" alt="" />
                                    <p className="frame-services-content-2" style={{ color: 'white' }}>Healthcare</p>
                                </div>
                            </div>
                            <div className="fw-col-indus hover_inAll">

                                <div className="frame-2-IJU">
                                    <img className="hc-image"
                                        src="./images/industires-bankingfinance.svg" alt="" />
                                    <p className="frame-services-content-2">Banking Finance</p>
                                </div>
                            </div>
                            <div className="fw-col-indus hover_inAll">

                                <div className="frame-2-IJU">
                                    <img className="hc-image"
                                        src="./images/industries-realestate.svg" alt="" />
                                    <p className="frame-services-content-2">Real Estate</p>
                                </div>
                            </div>
                            <div className="fw-col-indus hover_inAll">

                                <div className="frame-2-IJU">
                                    <img className="hc-image"
                                        src="./images/industries-realestate.svg" alt="" />
                                    <p className="frame-services-content-2">Social Network</p>


                                </div>
                            </div>
                        </div>

                        <div className="fw-row" style={{ display: 'flex' }}>
                            <div className="fw-col-indus hover_inAll">

                                <div className="frame-2-IJU">
                                    <img className="hc-image"
                                        src="./images/industries-events.svg" alt="" />
                                    <p className="frame-services-content-2">Events & Tickets</p>


                                </div>
                            </div>
                            <div className="fw-col-indus hover_inAll">

                                <div className="frame-2-IJU">
                                    <img className="hc-image"
                                        src="./images/industries-transport.svg" alt="" />
                                    <p className="frame-services-content-2">Transport & Automotive</p>


                                </div>
                            </div>
                            <div className="fw-col-indus hover_inAll">

                                <div className="frame-2-IJU">
                                    <img className="hc-image"
                                        src="./images/industries-ecommerce.svg" alt="" />
                                    <p className="frame-services-content-2">E-Commerce</p>


                                </div>
                            </div>
                            <div className="fw-col-indus hover_inAll">

                                <div className="frame-2-IJU">
                                    <img className="hc-image"
                                        src="./images/industries-media.svg" alt="" />
                                    <p className="frame-services-content-2">Media & Entertainment</p>


                                </div>
                            </div>
                            <div className="fw-col-indus hover_inAll">

                                <div className="frame-2-IJU">
                                    <img className="hc-image"
                                        src="./images/industries-elearnign.svg" alt="" />
                                    <p className="frame-services-content-2">
                                        Education &
                                        eLearning
                                    </p>


                                </div>
                            </div>
                            <div className="fw-col-indus hover_inAll">

                                <div className="frame-2-IJU">
                                    <img className="hc-image"
                                        src="./images/industries-directory.svg" alt="" />
                                    <p className="frame-services-content-2">Directory</p>


                                </div>
                            </div>
                        </div>

                        <div className="fw-row" style={{ display: 'flex' }}>
                            <div className="fw-col-indus hover_inAll">

                                <div className="frame-2-IJU">
                                    <img className="hc-image" src="./images/industries-travelhospitality.svg" alt="" />
                                    <p className="frame-services-content-2">
                                        Travel & Hospitality</p>


                                </div>
                            </div>
                            <div className="fw-col-indus hover_inAll">

                                <div className="frame-2-IJU">
                                    <img className="hc-image" src="./images/industries-foodandrest.svg" alt="" />
                                    <p className="frame-services-content-2">Food & Restaurant </p>


                                </div>
                            </div>
                            <div className="fw-col-indus hover_inAll">

                                <div className="frame-2-IJU">
                                    <img className="hc-image" src="./images/industries-enterprise.svg" alt="" />
                                    <p className="frame-services-content-2">Enterprise</p>


                                </div>
                            </div>
                            <div className="fw-col-indus hover_inAll">

                                <div className="frame-2-IJU">
                                    <img className="hc-image" src="./images/industires-on-demand.svg" alt="" />
                                    <p className="frame-services-content-2">On-Demand Service</p>
                                </div>
                            </div>
                        </div>
                        <div className="fw-row">
                            <div className="fw-col-xs-12 ">
                                <div className="fw-divider-space" style={{ marginTop: '60px' }}></div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}


export default Iotsolutions;
